"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var _default = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The `cloudinary` object that attaches this image to a Cloudinary account. */
  cloudinary: _propTypes.default.object.isRequired,

  /** The image ID that is stored in Cloudinary for this image. */
  cloudinaryImageId: _propTypes.default.string.isRequired,

  /** The width to make the image transformation (typically half of the 2x source width for crisp images). */
  width: _propTypes.default.number,

  /** The height to make the image transformation (typically half of the 2x source height for crisp images). */
  height: _propTypes.default.number,

  /** The watermark settings that should be applied to the image. See the <a href="http://cloudinary.com/documentation/image_transformations#adding_image_overlays" target="_blank">Cloudinary documentation</a> for details. */
  watermark: _propTypes.default.shape({
    /** The name of the image to use as the watermark. */
    overlay: _propTypes.default.string.isRequired,

    /** The x position of the watermark. */
    x: _propTypes.default.number.isRequired,

    /** The y position of the watermark. */
    y: _propTypes.default.number.isRequired,

    /** How to crop the watermark image. */
    crop: _propTypes.default.string,

    /** The corner to put the watermark in. */
    gravity: _propTypes.default.string,

    /** The width of the watermark image. */
    width: _propTypes.default.number,

    /** The opacity of the watermark. */
    opacity: _propTypes.default.number
  }),

  /** Optional function to execute when the image is loaded. */
  onLoad: _propTypes.default.func,

  /** Optional number to control image quality. Higher number is higher quality and higher file size. Defaults to 75. */
  quality: _propTypes.default.number
};
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/CloudinaryImage/CloudinaryImagePropTypes.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();